<template>
  <div class="example">
    <b-card>
      <b-card-header>
        <b-card-title>Cost Analysis</b-card-title>
        <!-- datepicker -->

        <!-- datepicker -->
      </b-card-header>
      <apexcharts
        height="350"
        type="bar"
        :options="chartOptions"
        :series="chartData"
      ></apexcharts>
    </b-card>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { BCard, BCardTitle, BCardHeader } from "bootstrap-vue";

export default {
  name: "Chart",
  props: {
    cost: {
      type: Array,
    },
  },
  components: {
    apexcharts: VueApexCharts,
    BCard,
    BCardHeader,
    BCardTitle,
  },

  computed: {
    chartOptions() {
      const simplifyDate = (dateStr) => {
        const date = new Date(dateStr);
        const day = date.getDate();
        const month = date.getMonth() + 1; // months are 0-indexed in JavaScript
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      };
      return {
        xaxis: {
          categories: this.cost.map((entry) => simplifyDate(entry.date)),
          labels: {
            offsetY: 5,
            style: {
              colors: "#b9b9c3",
              fontSize: "0.857rem",
            },
          },
          title:{
            text: "Date",
            style: {
            color:" #b9b9c3",
            fontSize: '14px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 600,
            cssClass: 'apexcharts-xaxis-title ',
          },
        },
        },
        yaxis:{
          labels: {
            offsetY: 5,
            style: {
              colors: "#b9b9c3",
              fontSize: "0.857rem",
            },
          },
          title:{
            text: "Amount (Rs)",
            style: {
            color: "#b9b9c3",
            fontSize: '14px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 600,
            cssClass: 'apexcharts-xaxis-title ',
          },
        },
        }
      };
    },
    chartData() {
      return [
        {
          name: "Total Cost",
          data: this.cost.map((entry) => entry.totalCost),
        },
      ];
    },
  },
};
</script>
